export default __webpack_public_path__ + "static/media/Medium Napalm Cocktail.25b594c3.PNG";